/* -----------------Globals--------------- */
import { NodeViewWrapper } from "@tiptap/react";

import type { Node } from "@tiptap/pm/model";
/* -----------------Child components--------------- */
import { ZoomImage } from "../../../MarkdownRenderer/ZoomImage";

export const ImageNodeViewWrapper = ({ node }: { node: Node }) => {
	return (
		<NodeViewWrapper>
			<ZoomImage allImages={[{ url: node.attrs.src }]} url={node.attrs.src} />
		</NodeViewWrapper>
	);
};
